const { NODE_ENV = ''} = process.env;
const environment = NODE_ENV.toLowerCase();

const aadTenantId = '5f4e175c-44de-4676-ae70-23ec941f455d';
let apiBaseUrl = 'https://datasolution-backend-prod.azurewebsites.net';
let aadClientId = 'd6c107cf-c4bc-40a3-b256-4c2aab5ed9fd';
let aadRedirectUri = 'https://datasolutions.agnicoeagle.com/';
let aadResourceId = 'https://agnicoeagle.onmicrosoft.com/AEM.DataSolution.WebAPI-Prod';
let odtHostname = 'https://odt.agnicoeagle.com';
switch (location.hostname) {
case 'localhost':
  apiBaseUrl = 'https://localhost:44300';
  aadClientId = '6b5dc28d-26be-4aae-91a1-3e7a7eace774';
  aadRedirectUri = 'http://localhost:3000';
  aadResourceId = 'https://agnicoeagle.onmicrosoft.com/AEM.CashFlow.Web-local';
  odtHostname = 'http://localhost:5000';
  break;
case 'datasolutions-beta.agnicoeagle.com':
  apiBaseUrl = 'https://ds-core-api-beta.agnicoeagle.com/';
  aadClientId = 'f2f98343-41f2-4710-8e78-909289e0ba31';
  aadRedirectUri = 'https://datasolutions-beta.agnicoeagle.com/';
  aadResourceId = 'https://agnicoeagle.onmicrosoft.com/AEM.DataSolution.WebAPI-Beta';
  odtHostname = 'https://odt-beta.agnicoeagle.com';
  break;
}

export {
  environment,
  apiBaseUrl,
  aadTenantId,
  aadClientId,
  aadRedirectUri,
  aadResourceId,
  odtHostname
};
